<template lang="html">
    <div class="side-tools" v-if="status > 0">
		<ul>
            <li><a class="back-top icon-top2" @click="goTop"></a></li>
		</ul>
	</div>
</template>

<script>
let t;
export default {
    data: function() {
        return {
            status: 0 // 边栏状态 0:不显示 1: 显示
        }
    },
    created() {
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        goTop() {
            window.scrollTo(0, 0);
        },
        handleScroll() {
            clearTimeout(t);
            t = setTimeout(this.updateSide, 50);
        },
        updateSide() {
            let ch = document.documentElement.clientHeight || document.body.clientHeight;
            let scroll = window.scrollY;
            if (scroll > ch) {
             this.status = 1;
            } else {
                this.status = 0;
            }
        }
    },
    components: {
    }
}
</script>

<style lang="scss">
.side-tools {
    position: fixed;
    right: 18px;
    bottom: 80px;
    z-index: 4;
    a {
        display: block;
        box-sizing: border-box;
        margin-top: 10px;
        padding-top: 13px;
        width: 50px;
        height: 50px;
        border: 1px solid #ddd;
        border-radius: 100%;
        background-color: rgba(76, 91, 109, 0.9);
        box-shadow: 0 3px 9px 0 rgba(102,102,102,0.40);
        color: #fff;
        text-align: center;
        touch-action: manipulation;
    }
    .back-top {
        background-color: rgba(255,255,255,0.9);
        color: #051b28;
        font-size: 24px;
    }
}

</style>



// WEBPACK FOOTER //
// SideTool.vue